import styled from 'styled-components'

export const CartWrapper = styled.div`
  padding: 1rem 0;
  overflow: auto;
  mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1) 1rem, rgba(0, 0, 0, 1) calc(100% - 1rem), rgba(0, 0, 0, 0));
`

export const CartSummary = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const CartSummaryTitle = styled.h2`
  font-family: ${props => props.theme.font.secondary};
  font-size: 28px;
  margin-top: 48px;
  margin-bottom: 0.5rem;
`

export const CartSummaryValue = styled.h3`
  font-family: ${props => props.theme.font.primary};
  font-weight: 600;
  font-size: 42px;
  color: ${props => props.theme.color.primary};
  margin-bottom: 0;
`
